import {Outlet} from 'react-router';

import Footer from 'pages/public/footer';

export default function App() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <Outlet />
      <Footer />
    </div>
  );
}
